'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-plot/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../sfdc-legend-utils/index.js');

var _index4 = _interopRequireDefault(_index3);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var layoutBuilder = _sdk2.default.layoutBuilder;
var DataFormatter = _sdk2.default.DataFormatter;
var ThemeFactory = _sdk2.default.ThemeFactory;
var runtime = _sdk2.default.runtime;
var ref = _sdk2.default.utils;
var configUtils = ref.configUtils;
var constants = ref.constants;
var dataUtils = ref.dataUtils;
var columnUtils = ref.columnUtils;
var layoutUtils = ref.layoutUtils;
var rowsUtils = ref.rowsUtils;
var sceneUtils = ref.sceneUtils;
var tooltipUtils = ref.tooltipUtils;
var percentageUtils = ref.percentageUtils;
var valueFctUtils = ref.valueFctUtils;
var referenceLineUtils = ref.referenceLineUtils;
var SortingEnum = _sdk2.default.enums.SortingEnum;
var ref$1 = _sdk2.default.rowsMetadata;
var RowsMetadata = ref$1.RowsMetadata;
var ref$2 = _sdk2.default.renderers;
var CellRendererFactory = ref$2.CellRendererFactory;
var ref$3 = _sdk2.default.chartLayouts;
var layoutsUtils = ref$3.layoutsUtils;
/**
 	Base class for Wave Charts
	Provides a default rendering framework to simplify the authoring Wave Charts
 */

var AbstractChart = function (AbstractPlot) {
  function AbstractChart(config, rows, rowsMetadata, props, delegate) {
    if (rowsMetadata === void 0) rowsMetadata = [];
    if (props === void 0) props = {};
    AbstractPlot.call(this, config, rows, new RowsMetadata(configUtils.hydrateRowsMetadata(rows, rowsMetadata)), props, delegate);

    if (this.rowsMetadata) {
      configUtils.hydrateConfig(this.config, this.rowsMetadata);
    }

    this.cellRendererConfigs = {}; // default config.theme first, other config options may rely on theme

    config.theme = config.theme || ThemeFactory.getInstance().getDefaultTheme(); // ensure we have at least one plot

    config.plots = config.plots && config.plots.length > 0 ? config.plots : this.getDefaultPlots(); // fix the config and apply defaults

    configUtils.fixConfig(config, this.getDefaultConfig()); // sanitize the config

    this.sanitizeConfig(); // the chart's properties

    this.chartProperties = dataUtils.defaultsDeep(this.getChartProperties(), {
      layout: "Flat",
      measuresRequired: true,
      rowsRequired: true,
      uniqueRowKeyRequired: true,
      keyColumns: [],
      supportsSorting: true,
      markType: constants.MARK_TYPE.BAR
    });
    config.sorting.enabled = config.sorting.enabled && this.chartProperties.supportsSorting;
    configUtils.enrichAxis(config); // set the mark type if specified

    if (this.chartProperties.markType) {
      configUtils.setMarkType(config, this.chartProperties.markType);
    } // preprocess time columns, key column on rows


    this.preprocessRows(); // setup chart layouts(color, radius, axis)

    this.chartLayouts = this.getChartLayouts();
    this.resetLayouts(); // sanitize legend

    if (this.config.legend) {
      _core2.default.defaults(this.config.legend, {
        vPad: constants.LEGEND.VPAD,
        hPad: constants.LEGEND.HPAD,
        position: constants.LEGEND.POSITION,
        inside: false,
        fitHeight: true,
        swatchSize: constants.COLOR_LEGEND.SWATCH.SIZE,
        swatchPadding: constants.COLOR_LEGEND.SWATCH.PADDING
      });
    } // preprocess the rows (eg to parse some fields)


    this.preprocessRowsBinInfo();
    this._state = props;
  }

  if (AbstractPlot) AbstractChart.__proto__ = AbstractPlot;
  AbstractChart.prototype = (0, _create2.default)(AbstractPlot && AbstractPlot.prototype);
  AbstractChart.prototype.constructor = AbstractChart;

  AbstractChart.prototype.getTooltipDefaultColumns = function getTooltipDefaultColumns() {
    return columnUtils.uniqueColumns(this.chartProperties.tooltipColumns);
  };
  /*
  * Returns a dataFormatter which is used to format the tooltip
  * based on the tooltip config
  * @return {dataFormatter}
  */


  AbstractChart.prototype.getDataFormatter = function getDataFormatter() {
    var ref = this;
    var config = ref.config;
    var rowsMetadata = ref.rowsMetadata;
    var tooltip = config.tooltip;
    var theme = config.theme;
    var column = tooltip.column;
    var showPercentage = tooltip.showPercentage;
    var showBinLabel = tooltip.showBinLabel;
    var text = tooltip.text;
    var showNullValues = tooltip.showNullValues;

    if (!column) {
      column = this.getTooltipDefaultColumns();
    }

    return new DataFormatter().setTooltipColumns(column).setShowPercentage(showPercentage).setShowBinLabel(showBinLabel).setShowNullValues(showNullValues).setTheme(theme).setRowsMetadata(rowsMetadata).setColorInfo(this.getColorInfo()).setText(text);
  };

  AbstractChart.prototype.getLegend = function getLegend() {
    if (!this.rows.length) {
      return;
    }

    var ref = this.chartProperties;
    var keyColumns = ref.keyColumns;
    var showColorLegend = ref.showColorLegend;
    if (showColorLegend === void 0) showColorLegend = true;
    var ref$1 = this.chartLayouts;
    var colorLayout = ref$1.colorLayout;
    var radiusLayout = ref$1.radiusLayout;
    var radialLegend;

    if (radiusLayout) {
      radialLegend = _index4.default.getRadialLegendFromLayout(radiusLayout, this.config);
    }

    var colorLegend;

    if (showColorLegend) {
      colorLegend = colorLayout.getType() != constants.CHART_LAYOUT.COLOR_TYPE.CONSTANT ? _index4.default.getColorLegendFromLayout(colorLayout, this.config, keyColumns) : _index4.default.getColorLegendFromPlots(this.config.plots.map(function (plot) {
        return {
          column: plot.column,
          mark: plot.mark,
          color: plot.color
        };
      }), this.config);
    }

    if (radialLegend) {
      return colorLegend ? _index4.default.getComboLegend(colorLegend, radialLegend) : radialLegend;
    } else {
      return colorLegend;
    }
  };

  AbstractChart.prototype.getColorInfo = function getColorInfo() {
    var colorLayout = this.chartLayouts.colorLayout;
    return colorLayout.isConstant() ? tooltipUtils.getColorInfoFromPlots(this.config.plots) : tooltipUtils.getColorInfoFromLayout(colorLayout);
  };

  AbstractChart.prototype.getKeyFct = function getKeyFct() {
    return this._keyFct;
  };

  AbstractChart.prototype.getInternalKeyColumn = function getInternalKeyColumn() {
    return this._internalKeyColumn;
  };

  AbstractChart.prototype.getInternalSortFct = function getInternalSortFct() {
    var sortColumnName = this.config.sorting.column[0].getName();
    return function (row) {
      return row[sortColumnName];
    };
  };
  /**
  * Returns an array of functions which each take a row as input, and
  * perform a mutating transform on that row (eg parse a time column)
  *
  * @return an array of row transform functions
  */


  AbstractChart.prototype.getRowsTransforms = function getRowsTransforms() {
    var this$1 = this;
    var transforms = [];
    var config = this.config;
    var ref = this.chartProperties;
    var uniqueRowKeyRequired = ref.uniqueRowKeyRequired;
    var keyColumns = ref.keyColumns; // process Key column

    var internalKeyColumn = configUtils.createInternalKeyColumn();
    var externalKeyColumns = configUtils.getColumns(config, "key");
    var trellisColumns = configUtils.getColumns(config, "trellis"); // - if no external key column specified, create key column by concat key columns from data row

    keyColumns = externalKeyColumns.length ? externalKeyColumns : trellisColumns.concat(keyColumns);
    var keyTransform = rowsUtils.parseInternalKeyTransform(internalKeyColumn, keyColumns); // keyTransform will be used when setSelection, setAnnotation, process to get row key

    this._keyTransform = keyTransform;
    this._internalKeyColumn = internalKeyColumn;
    this._keyFct = valueFctUtils.getValueFct({
      field: internalKeyColumn,
      defaultValue: ""
    });
    transforms.push(keyTransform); // process time columns

    var timeColumns = configUtils.getTimeColumns(config);
    timeColumns.forEach(function (column) {
      column.setInternalColumnName(column.getName() + "$parsed");
      transforms.push(rowsUtils.parseTimeRowTransform(column));
    }); // process percentage value for rows

    var ref$1 = this.chartProperties;
    var percentGroupColumns = ref$1.percentGroupColumns;
    if (percentGroupColumns === void 0) percentGroupColumns = [];
    var groups = configUtils.getColumns(config, "trellis").concat(percentGroupColumns);
    transforms.push(percentageUtils.getPercentRowTransform(this.rows, groups, this.rowsMetadata.getColumnsByType(constants.COLUMN_TYPE.MEASURE))); // filter out rows with duplicate keys

    if (uniqueRowKeyRequired) {
      var keyMap = {};
      transforms.push(function (row) {
        var key = this$1._keyFct(row);

        if (keyMap[key]) {
          return null;
        } else {
          keyMap[key] = true;
          return row;
        }
      });
    } // For time colunms, it doesn't make sense to keep rows that are missing
    // don't have a time value, so remove them.
    // We do this transforms after all other transforms have run


    if (timeColumns.length > 0) {
      transforms.push(function (row) {
        if (row != null) {
          var hasMissingValues = _core2.default.filter(timeColumns.map(function (column) {
            return row[column.getName()] == null || row[column.getName()] == "";
          })).length > 0;
          return hasMissingValues ? null : row;
        } else {
          return null;
        }
      });
    }

    return transforms;
  };
  /**
   *  Preprocess the rows with row transforms
   */


  AbstractChart.prototype.preprocessRows = function preprocessRows() {
    var rowTransforms = this.getRowsTransforms();

    if (rowTransforms.length == 0) {
      return;
    }

    var transform = rowTransforms.length == 1 ? rowTransforms[0] : dataUtils.flow(rowTransforms); // transform rows and remove "null" rows

    this.rows = _core2.default.filter(this.rows.map(transform));

    this._sortRows();
  };
  /**
   * Preprocess bins infomation for rows
   */


  AbstractChart.prototype.preprocessRowsBinInfo = function preprocessRowsBinInfo() {
    if (configUtils.isBinned(this.config)) {
      var colorLayout = this.chartLayouts.colorLayout;
      var colorColumn = colorLayout.getField();
      var columnName = colorColumn.getName();
      var binsInfo = colorLayout.getBinsInfo();
      colorColumn.setInternalColumnName(constants.CHART_LAYOUT.COLOR_TYPE.BINS);
      var transformFct = rowsUtils.getInternalValueTransform(colorColumn, function (row) {
        var binIndex = colorLayout.getBinIndex(row[columnName], binsInfo);
        var binLabel = colorLayout.getLabels()[binIndex];
        return {
          value: binIndex,
          label: binLabel
        };
      });
      this.rows = this.rows.map(transformFct);
    }
  };
  /**
   * When rows changed
   *
   * rows become different from rows passed into constructor, it could happen in
   * trellis, when we need to truncate rows to avoid overflow number of cells
   *
   *
   * @param  {Array} rows, new data rows
   * @param  {boolean} needsReprocess, whether we need to reprocess rows
   */


  AbstractChart.prototype.onChartRowsChanged = function onChartRowsChanged(rows, needsReprocess) {
    this.rows = rows; // update chartLayouts(they are calculated based on rows)

    this.chartLayouts = this.getChartLayouts(); // may need to reprocess

    if (needsReprocess) {
      this.preprocessRows();
    }
  };

  AbstractChart.prototype.onChartSizeChanged = function onChartSizeChanged(w, h) {
    var ref = this.chartLayouts;
    var radiusLayout = ref.radiusLayout;

    if (radiusLayout) {
      radiusLayout.setRelativeSize(Math.min(w, h));
    }
  }; // Renders a Cell by delegating to a CellRenderer


  AbstractChart.prototype.renderCell = function renderCell(cell, cellRendererConfig, renderingCtx) {
    // get the cell's rendering config
    cellRendererConfig = cellRendererConfig || {}; // create a cell renderer

    var cellRenderer = cellRendererConfig.cellRenderer || CellRendererFactory.get().getCellRenderer(this, cell, cellRendererConfig); // render the cell

    runtime.getPerf().mark(cell.key);
    cellRenderer.render(this, cell, cellRendererConfig, renderingCtx);
    runtime.getPerf().endMark(cell.key); // apply any cell transforms

    if (cellRendererConfig) {
      sceneUtils.applyTransforms(cell, cellRendererConfig.transforms);
    }
  };
  /**
   * Initialize scene for chart
   *
   *
   * @param  {Object} config to render
   * @param  {Array} rows to render
   * @param  {Object} ctx shared with plot/postPlot calls later
   * @return {Scene}
   */


  AbstractChart.prototype.initScene = function initScene(config, rows, ctx) {
    var size = config.size;
    var transforms = config.transforms;
    var padding = config.padding;
    var selectMode = config.selectMode;
    var ref = this.chartProperties;
    var layout = ref.layout;
    var cellSizes = ref.cellSizes;
    var keyColumns = ref.keyColumns;
    var axisTitleMaxLines = ref.axisTitleMaxLines;
    var scene = layoutBuilder.build({
      layout: layout,
      hasTooltip: config.hasTooltip,
      size: size,
      transforms: transforms,
      padding: padding,
      selectMode: selectMode,
      configLayout: config.layout,
      cellSizes: cellSizes,
      axisTitleMaxLines: axisTitleMaxLines
    });
    scene.set({
      selectionKeyFct: this._keyFct,
      keyTransform: this._keyTransform
    });
    return scene;
  };

  AbstractChart.prototype.plot = function plot(config, rows, scene, ctx) {
    var this$1 = this;

    if (!ctx) {
      ctx = {};
    }

    layoutUtils.adjustLayout(scene, config);
    var renderingCtx = {
      config: config,
      rows: rows,
      scene: scene,
      ctx: ctx
    };
    var renderedCells = {}; // if a cell rendering order is specified, render those cells first

    if (this.cellRenderingOrder) {
      this.cellRenderingOrder.forEach(function (cellName) {
        var cell = scene.cellByKey(cellName);
        this$1.renderCell(cell, this$1.cellRendererConfigs[cell.key], renderingCtx);
        renderedCells[cell.key] = cell;
      });
    } // now render the other cells ordered by key for repeatability


    _core2.default.sortBy(scene.getCells(), "key").forEach(function (cell) {
      // if the cell hasn't been rendered, render it
      if (!_core2.default.has(renderedCells, cell.key)) {
        this$1.renderCell(cell, this$1.cellRendererConfigs[cell.key], renderingCtx);
      }
    });
  };

  AbstractChart.prototype.postPlot = function postPlot(config, rows, scene, ctx) {};

  AbstractChart.prototype.hasRows = function hasRows(rows) {
    var ref = this.chartProperties;
    var rowsRequired = ref.rowsRequired;
    return !rowsRequired || rows.length > 0;
  };

  AbstractChart.prototype.hasMeasures = function hasMeasures(rows) {
    var ref = this.chartProperties;
    var measuresRequired = ref.measuresRequired;
    var measureColumns = ref.measureColumns;
    return !measuresRequired || rowsUtils.hasMeasures(rows, measureColumns);
  };

  AbstractChart.prototype.isEmpty = function isEmpty(rows) {
    return !this.hasRows(rows) || !this.hasMeasures(rows);
  }; // override to sanitize the config


  AbstractChart.prototype.sanitizeConfig = function sanitizeConfig() {
    var this$1 = this;
    AbstractPlot.prototype.sanitizeConfig.call(this);
    this.config.sorting.enabled = configUtils.isSortingSupported(this.config);
    var plots = this.config.plots;
    plots.forEach(function (plot, i) {
      plot.referenceLines = referenceLineUtils.getValidReferenceLines(plot.referenceLines || []);

      if (plot.color == null) {
        plot.color = configUtils.getPaletteColor(this$1.config.theme, i, plots.length);
      } // TODO: make this generic


      var ref = this$1.config;
      var measureAxis1 = ref.measureAxis1;
      var measureAxis2 = ref.measureAxis2;

      if (plot.column == null) {
        if (i == 0 && measureAxis1 && measureAxis1.column) {
          plot.column = measureAxis1.column;
        } else if (i == 1 && measureAxis2 && measureAxis2.column) {
          plot.column = measureAxis2.column;
        }
      }
    });
  }; // override to provide config defaults


  AbstractChart.prototype.getDefaultConfig = function getDefaultConfig() {
    return {
      tooltip: {},
      sorting: {
        internal: false,
        enabled: true
      }
    };
  };

  AbstractChart.prototype.getChartProperties = function getChartProperties() {
    return {};
  };

  AbstractChart.prototype.getChartLayouts = function getChartLayouts() {
    // by default the chart's colorLayout is the colorLayout of plots[0]
    return {
      colorLayout: this.getColorLayout()
    };
  };
  /**
  	Get the colorLayout for a plot at a given index
  */


  AbstractChart.prototype.getColorLayout = function getColorLayout(ref) {
    if (ref === void 0) ref = {};
    var i = ref.i;
    if (i === void 0) i = 0;
    var rows = ref.rows;
    if (rows === void 0) rows = this.rows;
    var legendSwatchType = ref.legendSwatchType;
    var ref$1 = this.config;
    var plots = ref$1.plots;
    var theme = ref$1.theme;
    var ref$2 = plots[i];
    var color = ref$2.color;
    var mark = ref$2.mark;
    legendSwatchType = legendSwatchType || mark;
    var colorLayout = layoutsUtils.getChartColorLayout(color, configUtils.getPaletteColor(theme, i, plots.length), rows, theme, legendSwatchType);
    return colorLayout;
  };
  /**
  	Get the chart's plot at a given index
  */


  AbstractChart.prototype.getPlot = function getPlot(i) {
    if (i === void 0) i = 0;
    return this.config.plots[i];
  }; // get the default plots for a chart
  // by default a chart has one plot


  AbstractChart.prototype.getDefaultPlots = function getDefaultPlots() {
    return dataUtils.range(0, this.getDefaultPlotCount()).map(function () {
      return {};
    });
  }; // the default number of plots for the chart


  AbstractChart.prototype.getDefaultPlotCount = function getDefaultPlotCount() {
    return 1;
  };

  AbstractChart.prototype.resetLayouts = function resetLayouts() {
    var ref = this.chartLayouts;
    var axisLayouts = ref.axisLayouts;

    if (axisLayouts) {
      var axisLayoutsArr = dataUtils.isPlainObject(axisLayouts) ? _core2.default.values(axisLayouts) : axisLayouts;
      this.resetAxisLayouts(axisLayoutsArr);
    }

    AbstractPlot.prototype.resetLayouts.call(this);
  };

  AbstractChart.prototype.resetAxisLayouts = function resetAxisLayouts(axisLayouts) {
    for (var i = 0; i < axisLayouts.length; i++) {
      axisLayouts[i] && axisLayouts[i].resetPlot();
    }
  };

  AbstractChart.prototype.settleAxisLayouts = function settleAxisLayouts(axisLayouts, axisSize, alignAxis, alignTicks) {
    if (alignAxis === void 0) alignAxis = false;
    if (alignTicks === void 0) alignTicks = false;
    axisLayouts = _core2.default.filter(axisLayouts);
    var numAxis = axisLayouts.length;

    for (var i = 0; i < numAxis; i++) {
      axisLayouts[i].setSize(axisSize);
    }

    if (alignAxis && numAxis > 1) {
      layoutsUtils.alignNumericAxisLayouts(axisLayouts, alignTicks);
    } else {
      axisLayouts.forEach(function (axisLayout) {
        return axisLayout.settleAxisDomainInfo();
      });
    }
  }; // internal row sorting


  AbstractChart.prototype._sortRows = function _sortRows() {
    var sorting = this.config.sorting;

    if (sorting.internal) {
      var order = sorting.order != null ? SortingEnum.fromValue(sorting.order) : SortingEnum.NONE;

      if (order != SortingEnum.NONE) {
        var internalSortFct = this.getInternalSortFct();

        if (internalSortFct != null) {
          this.rows = _core2.default.sortBy(this.rows, this.getInternalSortFct());

          if (order == SortingEnum.DESC) {
            this.rows = this.rows.reverse();
          }
        }
      }
    }
  };

  return AbstractChart;
}(_index2.default);

exports.default = AbstractChart;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;